import { sdkRequest } from '@eventbrite/http';
import { getExperiment } from '@eventbrite/statsig';
import {
    LOCATION_TARGETING_STATSIG_EXPERIMENT,
    RENDER_LOCATION_TARGETING,
    RENDER_LOCATION_TARGETING_DEFAULT,
} from '../constants/locationTargeting';

export const checkEbAdsEventEligibility = async (eventId: string) => {
    try {
        const isAuthed = window.__SERVER_DATA__?.user.isAuthenticated;
        if (!isAuthed) return;

        // TODO: Remove this once the experiment is over
        const locationTargetingExperimentEnabled =
            getExperiment<boolean, boolean>(
                LOCATION_TARGETING_STATSIG_EXPERIMENT,
                RENDER_LOCATION_TARGETING,
                RENDER_LOCATION_TARGETING_DEFAULT,
            ) || false;

        const urlParams = new URLSearchParams();

        // In the case that the experiment is disabled, we want to pass the override param to the API
        // Falling back to the original eligibility check
        if (!locationTargetingExperimentEnabled)
            urlParams.set('launch_location_targeting_override', '0');

        const url = `/api/v3/promoted_content/organizations/eb-ads-event-eligible/${eventId}/?`;

        const data = await sdkRequest(url + urlParams.toString());

        return data;
    } catch (error) {
        return null;
    }
};
